// useCompanyNames.js — 회사 코드 → 작업 대상과 같은 회사 이름 (2026-10-15)
//   사용자: "왜 통합관리에 SUNCREAM SUNCREAM2라고 떠? 작업대상과 같이 유기자차 무기자차로 떠야지"
//   이름 출처 = 작업 대상 회사 목록(useCompanyScope().companies). extra(예: 통합 메뉴 관리가 받은 테넌트 회사 목록)를 주면
//   그 이름을 먼저 쓴다. 목록에 없는 회사는 코드 그대로.
import { useMemo } from 'react';
import { useCompanyScope } from './CompanyScopeContext';
import { companyNameLookup } from './integratedScope';

export function useCompanyNames(extra = null) {
  const scope = useCompanyScope();
  const companies = scope?.companies;
  return useMemo(() => companyNameLookup(extra, companies), [extra, companies]);
}
